const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

const AUTH_TOKEN_KEY = 'auth_token';
const AUTH_USER_KEY = 'auth_user';
const AUTH_DOMAIN_KEY = 'auth_domain';
const AUTH_IS_ADMIN_KEY = 'auth_is_admin';
const AUTH_EXPIRES_KEY = 'auth_expires';

export const login = async (username, password) => {
  try {
    console.log('[AuthAPI] Attempting login for username:', username);
    
    const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Login failed' }));
      throw new Error(errorData.error || 'Invalid username or password');
    }

    const data = await response.json();
    console.log('[AuthAPI] Login successful for username:', data.username);
    
    // Store authentication data in localStorage
    localStorage.setItem(AUTH_TOKEN_KEY, data.token);
    localStorage.setItem(AUTH_USER_KEY, data.username);
    localStorage.setItem(AUTH_DOMAIN_KEY, data.domain ?? data.username);
    localStorage.setItem(AUTH_IS_ADMIN_KEY, data.isAdmin ? 'true' : 'false');
    localStorage.setItem(AUTH_EXPIRES_KEY, data.expiresAt);
    
    return data;
  } catch (error) {
    console.error('[AuthAPI] Login error:', error);
    throw error;
  }
};

export const logout = () => {
  console.log('[AuthAPI] Logging out user');
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem(AUTH_DOMAIN_KEY);
  localStorage.removeItem(AUTH_IS_ADMIN_KEY);
  localStorage.removeItem(AUTH_EXPIRES_KEY);
};

export const isAuthenticated = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const expiresAt = localStorage.getItem(AUTH_EXPIRES_KEY);
  
  if (!token) {
    return false;
  }
  
  // Check if token has expired
  if (expiresAt) {
    const expirationDate = new Date(expiresAt);
    if (expirationDate < new Date()) {
      console.log('[AuthAPI] Token has expired');
      logout();
      return false;
    }
  }
  
  return true;
};

export const getAuthToken = () => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

export const getAuthUser = () => {
  return localStorage.getItem(AUTH_USER_KEY);
};

export const getAuthDomain = () => {
  return localStorage.getItem(AUTH_DOMAIN_KEY) || localStorage.getItem(AUTH_USER_KEY);
};

export const getAuthIsAdmin = () => {
  return localStorage.getItem(AUTH_IS_ADMIN_KEY) === 'true';
};
